export default "__VITE_ASSET__BtlVHA0v__"